export default __webpack_public_path__ + "static/media/13_Liska_obecna_mezistromy.cz_thumb-min.c13111b0.jpg";